import { TableTemplate } from 'types/tableTemplate';

export const surgerieClosedTableTemplate: TableTemplate[] = [
  {
    id: 'action',
    description: 'Ações',
    originalId: 'action',
    width: 60,
  },
  {
    id: 'formattedCreatedAt',
    description: 'Criado em',
    originalId: 'created_at',
    width: 100,
  },
  {
    id: 'formattedClosedAt',
    description: 'Fechado em',
    originalId: 'closed_at',
    width: 100,
  },
  {
    id: 'closed_by',
    description: 'Operador',
    originalId: 'closed_by',
    width: 150,
  },
  {
    id: 'formattedPatientName',
    description: 'Paciente',
    originalId: 'formattedPatientName',
    width: 220,
  },
  {
    id: 'formattedProcedureName',
    description: 'Procedimento',
    originalId: 'formattedProcedureName',
    width: 240,
  },
  {
    id: 'formattedDoctorName',
    description: 'Médico',
    originalId: 'formattedDoctorName',
    width: 260,
  },
  {
    id: 'formattedHospitalName',
    description: 'Hospital',
    originalId: 'formattedHospitalName',
    width: 300,
  },
  {
    id: 'formattedDoctorValue',
    description: 'Vl. Médico',
    originalId: 'value_doctor',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedHospitalValue',
    description: 'Vl. Hospital',
    originalId: 'value_hospital',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedPackagesValue',
    description: 'Vl. Pacotes',
    originalId: 'value_packages',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedAnesthetistValue',
    description: 'Vl. Anest.',
    originalId: 'value_anesthetist',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedMarkupValue',
    description: 'Markup',
    originalId: 'value_markup',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedTotalValue',
    description: 'Vl. Total',
    originalId: 'value_total',
    width: 100,
    dataType: 'number',
  },
  {
    id: 'formattedValueEntry',
    description: 'Vl. Entrada',
    originalId: 'value_entry',
    width: 100,
    dataType: 'number',
  },
  {
    id: 'formattedValuePaid',
    description: 'Vl. Pago',
    originalId: 'value_paid',
    width: 120,
    dataType: 'number',
    backgroundColor: '#26c52eff',
    color: '#fff',
  },
];
